// @flow

import { useEffect } from "react";
import { connect } from "react-redux";
import type { Dispatch } from "redux-thunk";
import { withRouter } from "react-router";
import { getTokenInfo } from "../../api/actions";

type OauthTokenValidatorProps = {
  token: string | null,
  logOutAction: () => {},
  redirectUrl?: string,
  dispatch: Dispatch,
  history: {
    push: (path: string) => void
  }
};

const OauthTokenValidator = ({
  token,
  logOutAction,
  redirectUrl,
  dispatch,
  history
}: OauthTokenValidatorProps): void => {
  useEffect(() => {
    if (token) {
      getTokenInfo(token).then(response => {
        const { status } = response;

        if (status === 401) {
          dispatch(logOutAction()).then(() => redirectUrl && history.push(redirectUrl));
        }
      });
    }
  }, [token]);

  return null;
};

export default withRouter(
  connect(
    state => ({ token: state.user.token }),
    dispatch => ({
      dispatch
    })
  )(OauthTokenValidator)
);
